// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ADD_FEED_POST = "Pridaj diskusiu";
export const ADD_MENU_ADD_BLOG_POST = "Pridaj na stenu";
export const BZ2_ADD_PRODUCT = "Pridaj inzer\u00e1t";
export const HOMEPAGE_ADD_BUTTON = "Pridaj...";
